import { render } from "./LegalMention.vue?vue&type=template&id=31b41180&scoped=true"
import script from "./LegalMention.vue?vue&type=script&lang=js"
export * from "./LegalMention.vue?vue&type=script&lang=js"

import "./LegalMention.vue?vue&type=style&index=0&id=31b41180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b41180"]])

export default __exports__